import { Authentication } from "../../types/authentication";

const authentication: Authentication = {
  logIn: "Log In",
  logOut: "Log Out",
  signUp: "Sign Up",
  captchaError: "Temporary error - please wait a moment and try again.",
  lockedUntilError:
    'Due to successive failed login attempts, your account is locked until {{time}}. For further assistance, please <a href="mailto:{{supportEmail}}?subject=account%20locked" target="_blank" rel="noreferrer">contact support</a>.',
  passwordHookError: "<p>Please <a>contact support</a> and quote 'password hook error'.</p>",
  customAccessTokenHookError:
    "<p>Failed to retrieve your account permissions.</p><p>Please <a>contact support</a>  and quote 'login permissions error'.</p>",
  profile: {
    title: "User Profile",
    name: "Name",
    email: "Email",
  },
  roles: {
    default: "User",
    admin: "Admin",
  },
};

export default authentication;
